// ===========================
// DOM Ready (Vanilla JS)
// ===========================
function applyDiscountAndShowPopup(button) {

    // Apply discount only once per browser session
    if (!sessionStorage.getItem("discountApplied")) {

        fetch("/discount/TAKE15", {
            method: "GET",
            credentials: "same-origin"
        }).then(() => {
            sessionStorage.setItem("discountApplied", "true");
        }).catch((err) => {
            console.error("Discount error:", err);
        });

    }

    // Add class to body
    document.body.classList.add("st-discount-popup");

    // Remove existing popup
    const oldPopup = document.querySelector(".discount-popup");
    if (oldPopup) {
        oldPopup.remove();
    }

    // Create popup
    const popup = document.createElement("div");
    popup.className = "discount-popup";

    popup.style.cssText = `
        position: fixed;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
        background: rgba(0,0,0,.65);
        backdrop-filter: blur(3px);
        opacity: 1;
        transition: opacity .5s ease;
        z-index: 99999;
    `;

    popup.innerHTML = `
        <div class="success-pop-up-discount">
            <div class="success-heading">
                <img src="https://cdn.shopify.com/s/files/1/0712/3714/0631/files/fluent_checkmark.svg?v=1778429420" alt="Success">
            </div>

            <div class="success-pop-up-text">
                <h3>SUCCESS!</h3>
                <p>Extra <b>15% OFF</b> is now auto-applied<br>at checkout!</p>
            </div>
        </div>
    `;

    document.body.appendChild(popup);

        // Auto close after 5 seconds
        setTimeout(function () {

            popup.style.opacity = "0";

            setTimeout(function () {
                popup.remove();
                document.body.classList.remove("st-discount-popup");
            }, 500);

        }, 5000);
    }

    
document.addEventListener("DOMContentLoaded", function () {
    // update cart count
    const cartCount = document.getElementById("cart-count");

    async function updateCartCount() {
        if (!cartCount) return;

        try {
            const response = await fetch("/cart.js");
            const cart = await response.json();

            cartCount.textContent = cart.item_count;
        } catch (error) {
            console.error("Failed to update cart count:", error);
        }
    }

    ["cart:update", "rebuy:cart.change"].forEach((eventName) => {
        document.addEventListener(eventName, updateCartCount);
    });


    // Prevent "#" buttons from jumping to the top
    document.querySelectorAll('.orange-btn[href="#"]').forEach(function (button) {
        button.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
    });

    // Testimonials Toggle
    const toggleBtn = document.querySelector(".most-recent-btn");
    const ratingsContainer = document.querySelector(".all-ratings");

    if (toggleBtn && ratingsContainer) {
        let isExpanded = false;

        toggleBtn.addEventListener("click", function () {
            isExpanded = !isExpanded;

            ratingsContainer.classList.toggle("show-all");

            toggleBtn.textContent = isExpanded
                ? "See Less Testimonials"
                : "See More Testimonials";
        });
    }

    // Disable Product Image Zoom
    document.querySelectorAll("zoom-dialog").forEach(function (dialog) {
        dialog.removeAttribute("open");

        dialog.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
    });

    // Disable pointer events on product images
    const images = document.querySelectorAll('.product__media img');

    if (images.length) {
        images.forEach(img => {
            img.style.pointerEvents = 'none';
        });
    }

    // form validation
    const form = document.querySelector(".ctm-contact-form");

        if (form) {
            let formSubmitted = false;

            const fields = {
                name: {
                    input: document.getElementById("contact-name"),
                    error: document.getElementById("name-error"),
                    validate: value => value.trim() !== "",
                    message: "Please enter your name."
                },
                phone: {
                    input: document.getElementById("contact-phone"),
                    error: document.getElementById("phone-error"),
                    validate: value => {
                        const digits = value.replace(/\D/g, "");
                        return digits.length >= 7 && digits.length <= 15;
                    },
                    message: "Please enter a valid phone number."
                },
                message: {
                    input: document.getElementById("contact-message"),
                    error: document.getElementById("message-error"),
                    validate: value => value === "" || value.trim() !== "",
                    message: "Message cannot contain only spaces."
                }
            };

            function validateField(field, showError = false) {
                const isValid = field.validate(field.input.value);

                if (isValid) {
                    field.error.style.display = "none";
                    return true;
                }

                if (showError) {
                    field.error.textContent = field.message;
                    field.error.style.display = "block";
                }

                return false;
            }

            form.addEventListener("submit", function (e) {
                formSubmitted = true;
                let isValid = true;

                Object.values(fields).forEach(field => {
                    if (!validateField(field, true)) {
                        if (isValid) {
                            field.input.focus();
                        }
                        isValid = false;
                    }
                });

                if (!isValid) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
            });

            Object.values(fields).forEach(field => {
                field.input.addEventListener("input", function () {
                    if (!formSubmitted) return;
                    validateField(field, true);
                });
            });
        }
    // cart quantity validation
    document.querySelectorAll('.cart-quantity-input').forEach(function(input) {
        input.addEventListener('input', function() {
            // Remove non-digits
            this.value = this.value.replace(/\D/g, '');

            // Allow only 6 digits
            if (this.value.length > 6) {
                this.value = this.value.slice(0, 6);
            }
        });

    });

});

(function () {
  function updateDiscountInputVisibility() {
    const discountComponent = document.querySelector(
      '[data-rebuy-component="discount-input"]'
    );

    if (!discountComponent) return;

    const discountForm = discountComponent.querySelector(
      '.rebuy-cart__discount-form'
    );

    if (!discountForm) return;

    const appliedDiscount = discountComponent.querySelector(
      '.rebuy-cart__discount-tag'
    );

    if (appliedDiscount) {
      // Coupon applied → hide input + Apply button
      discountForm.style.display = 'none';
    } else {
      // Coupon removed → show input + Apply button
      discountForm.style.display = '';
    }
  }

  function initDiscountWatcher() {
    updateDiscountInputVisibility();

    const observer = new MutationObserver(function () {
      updateDiscountInputVisibility();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initDiscountWatcher, 500);
    });
  } else {
    setTimeout(initDiscountWatcher, 500);
  }

  // Rebuy events
  document.addEventListener('rebuy:cart.change', function () {
    setTimeout(updateDiscountInputVisibility, 100);
  });

  document.addEventListener('rebuy:smartcart.ready', function () {
    setTimeout(updateDiscountInputVisibility, 100);
  });

  document.addEventListener('rebuy:smartcart.show', function () {
    setTimeout(updateDiscountInputVisibility, 100);
  });
})();

// ===========================
// jQuery Ready
// ===========================
jQuery(function ($) {

    // Product Slider
    if ($(".enable-product-slider").length && !$(".enable-product-slider").hasClass("slick-initialized")) {
        $(".enable-product-slider").slick({
            autoplay: false,
            autoplaySpeed: 5000,
            speed: 400,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        autoplay: true
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    // Review Slider
    if ($(".reviwer-swiper").length && !$(".reviwer-swiper").hasClass("slick-initialized")) {
        $(".reviwer-swiper").slick({
            autoplay: false,
            autoplaySpeed: 5000,
            speed: 600,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            infinite: true,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 1,
                        autoplay: true
                    }
                }
            ]
        });
    }

    // Close Top Bar
    $(document).on("click", ".close-btn", function () {
        $(".topbar").slideUp(350);
        $("body").addClass("topbar-spacing");
    });

    $('.hamburger').click(function(){
        $('.header').toggleClass('active');
    });

});